import Organization from './Organization';
import NotificationType from './typelist/NotificationType';

export default class Notification {
  initiatedBy?: any;
  to?: any;
  type?: NotificationType;
  data?: any;

}
